import { Component, OnInit ,ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-hojatrabajo',
  templateUrl: './hojatrabajo.component.html',
  styleUrls: ['./hojatrabajo.component.scss']
})
export class HojatrabajoComponent implements OnInit {  
  @ViewChild('cht',null) cht;
  @ViewChild('chtd',null) chtd;
  @ViewChild('chimg',null) chimg;
  
  constructor(
    public authService: AuthService,
    public router: Router) { }
loading;
  ngOnInit() {
    this.a_=Number(localStorage.getItem("a"));
    this.p_=Number(localStorage.getItem("p"));
    this.usuario=Number(localStorage.getItem("usuario"));
    //console.log("usuario:"+this.usuario);
    this.ls_ht();
    this.ls_cliente();
    this.get_org();
    this.loading=false;
    this.bnd_list_ht=true;
  }
  cliente;
  org;
  org_;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
              //console.log(data);
                this.org=data;
                for(var i=0;i<this.org.length;i++){
                  if(this.org[i].director==1)
                  this.org_.push(this.org[i]);
                }
                
                
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  ls_cliente(){
    let postData = {
      id:Number(localStorage.getItem("id_cliente"))
    } 
    this.authService.service("/api/get_cliente_by_id",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.cliente=data;
          //console.log(data)
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  bnd_list:Boolean=true;
  togle_raci_list(){
    if(this.bnd_list==true){
      this.bnd_list=false
    }else{
      this.bnd_list=true;
    }
  }
  n_ht(){
    this.ht_name="";
    this.bndSaveht=true;
    this.ht_name="";
    this.fecha_ht="";
    this.codigo_ht="";

  }
  bnd_list_ht=false;
  a_=0;
  p_=0;
  bndSaveht=true;
  
  htd;
  ht_list;
  bnd_ht=false;
  togle_ht_list(){
    if(this.bnd_list_ht==true){
      this.bnd_list_ht=false
    }else{
      this.bnd_list_ht=true;
      this.bnd_ht=false;
    }
  }
 
  id_ht=0;
  ht_usuario;
  rev_ht=0;
  v_ht(itm){
    this.bnd_ht=true;
    this.bnd_list_ht=false;
    this.id_ht=itm.id;
    this.ht_name=itm.nombre;
    this.fecha_ht=itm.fecha;
    this.codigo_ht=itm.codigo;
    this.rev_ht=itm.n;
    this.ht_usuario=itm.usuario_nombre;
    this.ls_ht_det();
  }
  
  img(i){
   //.log(i)
    if(i===null){
      return "image-none.jpg"
    }
    return i;
  }
  
  ls_ht_det(){
    this.htd=[];
    let postData = {
      id:this.id_ht
    } 
    this.authService.service("/api/get_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
         
          for(var i=0 ;i<res.length;i++){
            var bnd_m=false;
            var bnd_im2=false;            
            var bnd_im3=false;
            var bnd_im4=false;
            if(res[i].img1!=null){bnd_im2=true;bnd_m=true}
            if(res[i].img2!=null){bnd_im3=true;bnd_m=true}
            if(res[i].img3!=null){bnd_im4=true;bnd_m=true}

            this.htd.push({n:i+1,
                id:res[i].id,
                simbolo1:res[i].simbolo1,
                simbolo2:res[i].simbolo2,
                simbolo3:res[i].simbolo3,
                simbolo4:res[i].simbolo4,
                principal:res[i].principal,
                importante:res[i].importante,
                razon:res[i].razon,
                tiempo:res[i].tiempo,
                img1:this.img(res[i].img1),
                img2:this.img(res[i].img2),
                img3:this.img(res[i].img3),
                img4:this.img(res[i].img4),
                bnd_im2:bnd_im2,
                bnd_im3:bnd_im3,
                bnd_im4:bnd_im4,
                bnd_m:bnd_m,
                url:res[i].url,
                role:res[i].role,
                rolecard:res[i].rolecard,

              });
          }
          //console.log(data)
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  
  chn(n,v){    
  }
  htdet={
    id:0,
    num:0,
    tipo:"",
    simbolo1:0,
    simbolo2:0,
    simbolo3:0,
    simbolo4:0,
    principal:"",
    importante:"",
    razon:"",
    tiempo:0,
    role:0,
    im1:"",im2:"",im3:"",im4:"",url:""
  };
  img_aux;
  n_img_aux=0;
  id_imag_aux=0;
public URL:any;
fileToUpload: File = null;
ext_(f:any) {
  //console.log(f);
  var c:string[]=f.split("/");
 return c[(c.length-1)]; 
}
uploadFileToActivity(){
  
    if (this.fileToUpload) {
     // console.log("upload")
      var reader = new FileReader();      
      reader.readAsDataURL(this.fileToUpload); // read file as data url
      const file = this.fileToUpload;      
      reader.onload = (event) => { 
        this.URL = reader.result;  
        var tmpDate = new Date();     //  Wed Oct 16 2013 12:37:29 GMT+0200
        var now = tmpDate.getTime();
        let data: any = {
          cveentevt: 1,
          name: now + '.' + this.ext_(file.type),
          firma: this.URL,
          idx: 1,
          id:this.id_imag_aux,
          n:this.n_img_aux
        }        
        //this.persona.foto=data.name;
        data.TYPE = 'pdf';
        
        data.FILENAME = 'files/' + now + '.pdf',        
         //this.loading =true;
       // console.log(data);          
          this.authService.upImagen_ht(data).then(res => {
            var mm = JSON.stringify(res)
            var dd = JSON.parse(mm)
            this.msg_foto="<span class=green>✔</span> ";
            //console.log("guardado");
            //this.img1.id = res[0].cveevtanx;
            //this.img1.url = this.urlwebimg +  now + ".png";
            this.chimg.nativeElement.click();
            this.ls_ht_det();
            //this.loading =false;
              //this.PDF =  dd.detailed_message            
            //swal.fire('DOCUMENTO SE GUARDO EXITOSAMENTE','DOCUMENTO SE GUARDO EXITOSAMENTE','success')
              // console.log(dd.detailed_message)              
            
          },error => {
            this.msg_foto=" <span style=color:red;>X error</span> ";
          }
          )
        }
      }
  }
  msg_foto;
  txt_fot;
  onSelectFile(event,idx) {
   // console.log(event);
    this.URL = event.target.files;
    this.fileToUpload = event.target.files[0];
  }
  upd_img(){
    this.uploadFileToActivity();   
  }
  chnimg(n,itm){
    this.id_imag_aux=itm.id;
    this.n_img_aux=n;
    switch (Number(n)) {
      case 1:
        this.img_aux=itm.img1
        break;
      case 2:
        this.img_aux=itm.img2
        break;
      case 3:
        this.img_aux=itm.img3
        break;
      case 4:
        this.img_aux=itm.img4
        break;
    
      default:
        break;
    }

  }
  nvo_htd(){    
    this.htdet.simbolo1=0,
    this.htdet.simbolo2=0,
    this.htdet.simbolo3=0,
    this.htdet.simbolo4=0,
    this.htdet.tipo="H";
    this.htdet.principal="";
    this.htdet.importante="";
    this.htdet.razon="";
    this.htdet.tiempo=0;
    this.htdet.im1="";
    this.htdet.im2="";
    this.htdet.im3="";
    this.htdet.im4="";
    this.htdet.url="";
    this.htdet.role=0;

    this.bndSavehtd=true;
  }
  del_htd(itm){
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          
          this.ls_ht_det();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });    
  }
  edt_htd(itm){
    ///console.log(itm);
    this.htdet.id=itm.id;
    this.htdet.simbolo1=itm.simbolo1;
    this.htdet.simbolo2=itm.simbolo2;
    this.htdet.simbolo3=itm.simbolo3;
    this.htdet.simbolo4=itm.simbolo4;
    this.htdet.tipo=itm.tipo;
    this.htdet.principal=itm.principal;
    this.htdet.importante=itm.importante;
    this.htdet.razon=itm.razon;
    this.htdet.tiempo=itm.tiempo;
    this.htdet.im1=itm.im1;
    this.htdet.im2=itm.im2;
    this.htdet.im3=itm.im3;
    this.htdet.im4=itm.im4;
    this.htdet.url=itm.url;
    this.htdet.role=itm.role;
    this.bndSavehtd=false;
  }
  role;
  upd_htd(){
    let postData = {
      id:this.htdet.id,
      simbolo1:Number(this.htdet.simbolo1),
      simbolo2:Number(this.htdet.simbolo2),
      simbolo3:Number(this.htdet.simbolo3),
      simbolo4:Number(this.htdet.simbolo4),
      principal:this.htdet.principal,
      importante:this.htdet.importante,
      razon:this.htdet.razon,
      tipo:this.htdet.tipo,
      tiempo:this.htdet.tiempo,
      url:this.htdet.url,
      role:this.htdet.role
    } 
    //console.log(postData);
    this.authService.service("/api/upd_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          this.ls_ht_det();
          this.chtd.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  gda_htd(){
    let postData = {
      id_hoja_trabajo:this.id_ht,
      simbolo1:Number(this.htdet.simbolo1),
      simbolo2:Number(this.htdet.simbolo2),
      simbolo3:Number(this.htdet.simbolo3),
      simbolo4:Number(this.htdet.simbolo4),
      principal:this.htdet.principal,
      importante:this.htdet.importante,
      razon:this.htdet.razon,
      tipo:this.htdet.tipo,
      tiempo:this.htdet.tiempo,
      url:this.htdet.url,
      role:this.htdet.role
    } 
    this.authService.service("/api/ins_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          
          this.ls_ht_det();
          this.chtd.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  bndSavehtd;
  ht_name;
  dupl_ht(itm){
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/dupl_ht",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_ht();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  del_ht(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_ht",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          this.ls_ht(); 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  msg_ht="";
  ls_ht(){
    let postData = {
      a_:this.a_,
      p_:this.p_
    } 
      //console.log(postData);
      this.ht_list=[];
      this.authService.service("/api/get_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            var tot=res.length;
            //console.log(res);
            if(tot==0){
              this.msg_ht="No result data";
            }
            for(var i=0;i<res.length;i++){
              this.ht_list.push({n:tot,
                id:res[i].id,
                usuario_nombre:res[i].usuario_nombre,
                nombre:res[i].nombre,
                codigo:res[i].codigo,
                fecha:res[i].fecha,
              });
              tot=tot-1;
            }
            //this.ht_list=data;
            //console.log(data)
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  fecha_ht;
  codigo_ht;
  usuario=0;
  gda_ht(){
    let postData = {
      nombre:this.ht_name,
      fecha:this.fecha_ht,
      codigo:this.codigo_ht,
      usuario:this.usuario,
      a:this.a_,
      p:this.p_
    } 
      //console.log(postData);
      this.authService.service("/api/ins_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.ls_ht();
            this.msg_ht="";
            this.bnd_list_ht=false;
            //console.log(data)
            this.cht.nativeElement.click();
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  ht(){
    let postData = {
      id:this.id_ht,
      nombre:this.ht_name,
      fecha:this.fecha_ht,
      codigo:this.codigo_ht,
      upd_suario:this.usuario,
      a:this.a_,
      p:this.p_
    } 
      //console.log(postData);
      this.authService.service("/api/upd_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.ls_ht(); 
            this.cht.nativeElement.click();
            //this.ht_list=res;
            //console.log(data)
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          }); 
  }
  edt_ht(itm){
    this.bndSaveht=false;
    //console.log(itm);
    this.id_ht=itm.id;
    this.ht_name=itm.nombre;
    this.fecha_ht=itm.fecha.substring(0,10);
    this.codigo_ht=itm.codigo;
  }

}
